import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  const services = [
    {
      icon: 'ri-line-chart-line',
      title: 'Management & Operations Consulting',
      description:
        'Comprehensive practice management solutions that streamline clinical and administrative operations, reduce burden, and build sustainable operational models.',
      featured: true,
    },
    {
      icon: 'ri-computer-line',
      title: 'Digital Transformation & IT Integration',
      description:
        'Modernize your digital infrastructure with CRM platforms, CMS strategy, EHR optimization, and teleconsultation platform integration.',
      featured: true,
    },
    {
      icon: 'ri-team-line',
      title: 'Patient Engagement Systems',
      description:
        'Implement digital intake workflows, patient engagement platforms, and automated communication systems to enhance patient experience.',
      featured: false,
    },
    {
      icon: 'ri-search-line',
      title: 'Marketing Strategy & SEO',
      description:
        'Drive patient acquisition through local search optimization, online visibility growth, and conversion-focused website performance.',
      featured: true,
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Workflow Automation',
      description:
        'Automate scheduling, intake, billing, and communications to reduce manual tasks and improve operational efficiency across your practice.',
      featured: false,
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Analytics & Reporting',
      description:
        'Gain performance visibility with custom dashboards, revenue cycle optimization, and data-driven insights for strategic decision-making.',
      featured: false,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
            OUR EXPERTISE
          </p>
          <h2 className="font-serif text-5xl font-bold text-navy-primary mb-8 max-w-3xl mx-auto">
            Comprehensive Clinical Practice Solutions
          </h2>
          <p className="text-base text-charcoal max-w-3xl mx-auto leading-relaxed">
            We deliver executive-level consulting that integrates practice
            management, digital transformation, and strategic growth frameworks
            tailored for modern clinical organizations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`rounded-3xl p-12 transition-all duration-300 hover:-translate-y-2 cursor-pointer ${
                service.featured
                  ? 'bg-navy-primary text-white shadow-xl'
                  : 'bg-white text-navy-primary shadow-lg hover:shadow-2xl'
              }`}
            >
              <div
                className={`w-16 h-16 flex items-center justify-center mb-6 ${
                  service.featured ? 'text-gold' : 'text-gold'
                }`}
              >
                <i className={`${service.icon} text-5xl`}></i>
              </div>

              <h3
                className={`text-2xl font-bold mb-5 ${
                  service.featured ? 'text-white' : 'text-navy-primary'
                }`}
              >
                {service.title}
              </h3>

              <div
                className={`w-10 h-0.5 mb-5 ${
                  service.featured ? 'bg-gold' : 'bg-gold'
                }`}
              ></div>

              <p
                className={`text-sm leading-relaxed mb-6 ${
                  service.featured ? 'text-gray-light' : 'text-charcoal'
                }`}
              >
                {service.description}
              </p>

              <Link
                to="/services"
                className={`inline-flex items-center text-sm font-medium ${
                  service.featured
                    ? 'text-gold hover:text-gold-light'
                    : 'text-gold hover:text-gold-light'
                } transition-colors duration-200 cursor-pointer`}
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link
            to="/services"
            className="inline-block px-10 py-4 border-2 border-gold text-gold text-base font-semibold rounded-lg hover:bg-gold hover:text-navy-primary transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;